import React from 'react';
import { motion } from 'framer-motion';
interface Stat {
  value: string;
  label: string;
}
interface StatsSectionProps {
  stats: Stat[];
}
export function StatsSection({
  stats
}: StatsSectionProps) {
  return <div className="bg-[var(--color-text)] py-16" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-112">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-113">
              <div className="text-4xl md:text-5xl font-bold text-[var(--color-primary)] mb-2" data-id="element-114">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-white/80 uppercase tracking-wide" data-id="element-115">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}